import React, { useState, useEffect, useRef } from "react";
import { Container, Grid, Card, Typography, Box } from "@mui/material";
import { styled } from "@mui/system";
import { motion } from "framer-motion";
import "../../CSS/WebDev.css";
import Footer from "../Footer";

const OurProcess = () => {

  const CustomCard = styled(motion(Card))({
    minHeight: "170px",
    padding: "20px",
    textAlign: "center",
    borderRadius: "12px",
    backdropFilter: "blur(10px)",
    backgroundColor: "rgba(52, 39, 153, 0.13)",
    boxShadow: "0px 4px 20px rgba(29, 7, 70, 0.67)",
    border: "1px solid rgba(29, 7, 70, 0.67)",
    color: "white",
  });

  const codeLines = [
    "&lt;!DOCTYPE html&gt;",
    "&lt;html lang=&quot;en&quot;&gt;",
    "&lt;head&gt;",
    "  &lt;meta charset=&quot;UTF-8&quot;&gt;",
    "  &lt;meta name=&quot;viewport&quot; content=&quot;width=device-width, initial-scale=1.0&quot;&gt;",
    "  &lt;title&gt;Let's Create! Join NexExcellency&lt;/title&gt;",
    "  &lt;link rel=&quot;stylesheet&quot; href=&quot;styles.css&quot;&gt;",
    "  &lt;style&gt;",
    "    body { background-color: #1a1a2e; color: white; font-family: 'Inter', sans-serif; text-align: center; }",
    "    .container { width: 80%; margin: auto; padding: 20px; border-radius: 8px; box-shadow: 0px 4px 20px rgba(255, 255, 255, 0.1); }",
    "    .highlight { color: #f39c12; font-weight: bold; font-size: 18px; }",
    "  &lt;/style&gt;",
    "&lt;/head&gt;",
    "&lt;body&gt;",
    "    showTime();",
    "  &lt;/script&gt;",
    "&lt;/body&gt;",
    "&lt;/html&gt;",
  ];


  const VSCodeScreen = () => {
    const [visibleLines, setVisibleLines] = useState(0);
    const vsCodeRef = useRef(null);
    let timeoutRef = useRef(null);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setVisibleLines(0);
            let index = 0;

            clearTimeout(timeoutRef.current);
            timeoutRef.current = setInterval(() => {
              setVisibleLines((prev) => {
                if (prev < codeLines.length) return prev + 1;
                clearInterval(timeoutRef.current);
                return prev;
              });
            }, 200);
          } else {
            clearInterval(timeoutRef.current);
            setVisibleLines(0);
          }
        },
        { threshold: 0.3 }
      );

      if (vsCodeRef.current) {
        observer.observe(vsCodeRef.current);
      }

      return () => {
        if (vsCodeRef.current) observer.unobserve(vsCodeRef.current);
        clearInterval(timeoutRef.current);
      };
    }, []);

    return (
      <>
        <Typography
          variant="h4"
          sx={{ color: "white", fontFamily: "'Inter', sans-serif", textAlign: "center", mb: 4 }}    >
          Our Web Developmet Service
        </Typography>
        <Box ref={vsCodeRef} sx={{ mb: 6, py: 4, borderRadius: "12px", padding: "2px" }}>
          <Box className="vs-code-content">
            <pre className="code-snippet">
              {codeLines.map((line, index) => (
                <code
                  key={index}
                  className={`code-line ${index < visibleLines ? "glow" : ""}`}
                  dangerouslySetInnerHTML={{ __html: highlightSyntax(line) }}
                ></code>
              ))}
            </pre>
          </Box>
        </Box>
      </>

    );
  };

  const highlightSyntax = (line) => {
    return line
      .replace(/(&lt;\/?\w+)/g, '<span class="tag">$1</span>') // HTML Tags
      .replace(/(".*?")/g, '<span class="string">$1</span>') // Strings
      .replace(/\b(function|console|meta|title|script|link|body|head|html|charset|rel)\b/g, '<span class="keyword">$1</span>'); // Keywords
  };

  return (
    <Container sx={{ py: 4 }}>
      <VSCodeScreen />

      <Typography
        variant="h4"
        sx={{ color: "#95a9bd", fontFamily: "'Inter', sans-serif", textAlign: "center", mb: 4 }}    >
        Our Process
      </Typography>

      {/* Process Cards (Below VSCode Section) */}
      <Box sx={{ mt: 6 }}>
        <Grid container spacing={3}>
          {[
            { step: "Step 1", title: "Discovery And Strategy", delay: 0, x: -100 },
            { step: "Step 2", title: "Design And Development", delay: 0, x: 100 },
            { step: "Step 3", title: "Testing And Launch", delay: 0.2, x: -100 },
            { step: "Step 4", title: "Ongoing Support And Growth", delay: 0.2, x: 100 },
          ].map((item, index) => (
            <Grid item xs={12} md={6}> {/* Both will be equal size */}
              <CustomCard
                initial={{ opacity: 0, x: item.x }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, ease: "easeOut", delay: item.delay }}
                viewport={{ once: true }}
                whileHover={{
                  boxShadow: "0px 0px 20px rgba(112, 5, 199, 0.9), 0px 0px 40px rgba(68, 6, 104, 0.6)",
                  transition: { duration: 0.3 },
                }}
              >
                <Typography variant="h5" sx={{ color: "white", fontFamily: "'Inter', sans-serif" }}>
                  {item.step}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "'Inter', sans-serif",
                    color: "#babbbf",
                    textAlign: "center",
                    marginTop: "25px",
                  }}
                >
                  {item.title}
                </Typography>
              </CustomCard>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box sx={{ mt: 6, textAlign: "center" }}>
        <Typography variant="h4" sx={{ color: "#95a9bd", fontFamily: "'Inter', sans-serif", mb: 4 }}>
          What We Offer
        </Typography>

        {[
          {
            title: "Custom Web Development",
            description: "Get a website built from ground up with your brand and user needs in mind. Our custom development ensuresyour website is unique , fast and optimised for conversation. ",
          },
          {
            title: "Responsive Web Design",
            description: "Your website should look good on any device. We design websites that are mobile friendly and fully responsive,ensuring seamless expirience across smartphones, tablets, dekstop.",
          },
          {
            title: "Maintainance And Support",
            description: "We rigorously test your web solution for performance, security, and user experience before deployment. We dont just build websites - we maintain and support them in order they stay fast, sequre and upto date. With performance monitoring,bug fixes, troubleshooting, content updates and enhancements.",
          },

        ].map((item, index) => (
          <Box key={index} sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              sx={{
                color: "white",
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                mb: 1,
              }}
            >
              {item.title}
            </Typography>
            <Typography sx={{ fontFamily: "'Inter', sans-serif", color: "#babbbf", fontSize: "16px" }}>
              {item.description}
            </Typography>
          </Box>
        ))}
      </Box>
      <Footer />
    </Container>
  );
};
export default OurProcess;
